































































































































































































































































































import Vue from 'vue';
import usuarioService from './usuario-service';
import empresaService from '../empresa/empresa-service';
import * as val from '../../base/validations';
import Api from '../../base/api.typings';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import routerService from '../../base/router-service';
import env from '../../env/env';
import areaService from '../area-atual/area-service';
import licencaService from '../licenca/licenca-service';
import gatewayService from '../gateway/gateway-service';
import { obterDiaMesAnoFormatado } from '../../utils/utils';

@Component
export default class UsuarioEditar extends Vue {
    @Prop() usuarioId: string;

    @Prop() tipoEditar: number;

    get usuarioCliente() {
        return (
            this.usuario.tipo ==
            Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Cliente
        );
    }

    obterDataFormatada(value: string) {
        if (value == null || value.length == 0) return '';
        return obterDiaMesAnoFormatado(value);
    }

    usuario: Api.App.Server.Usuario.Editar.Command = null;

    empresas: Api.App.Server.Empresa.Listar.EmpresaDto[] = [];

    licencas: Api.App.Server.Licenca.ListarParaUsuario.Dto[] = [];
    assinaturas: Api.App.Server.Gateway.ListarAssinaturasParaUsuario.AssinaturaDto[] = [];
    logs: Api.App.Server.Gateway.ListarAssinaturasParaUsuario.LogDto[] = [];
    faturas: Api.App.Server.Gateway.ListarAssinaturasParaUsuario.FaturaRecenteDto[] = [];

    usuarioFoto: string = null;
    areaAtual: string = null;

    tipos = [
        {
            value:
                Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Administrador,
            text: 'Administrador',
        },
        {
            value: Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Cliente,
            text: 'Cliente',
        },
        {
            value: Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Contador,
            text: 'Contador',
        },
    ];

    get headerLogs() {
        return {
            headers: [
                { text: 'Assinatura', value: 'assinaturaId' },
                { text: 'Descrição', value: 'descricao' },
                { text: 'Detalhes', value: 'detalhes' },
            ],
            logs: this.logs,
        };
    }

    obterNomeProduto(item) {
        let result = item.titulo;
        if (item.subtitulo) {
            result += ` - ${item.subtitulo}`;
        }

        return result;
    }

    async visualizarLicenca(licencaId: string) {
        await routerService.goTo('licenca-visualizar', { licencaId });
    }

    private async listarEmpresas() {
        let resultado = await empresaService.listar({});

        this.empresas = resultado.itens;
    }

    private async listarLicencas() {
        const { licencas } = await licencaService.listarParaUsuario({
            usuarioId: this.usuarioId,
        });

        this.licencas = licencas;
    }

    private async listarAssinaturas() {
        const {
            assinaturas,
            logs,
            faturas,
        } = await gatewayService.listarAssinaturas({
            usuarioId: this.usuarioId,
        });

        this.assinaturas = assinaturas;
        this.logs = logs;
        this.faturas = faturas;
    }

    get carregando() {
        return !this.usuario;
    }

    async created() {
        this.areaAtual = await areaService.obterAreaPadrao();
        if (this.usuarioId) {
            if (this.areaAtual == 'admin') {
                this.obterParaEditar();
                this.listarEmpresas();
            }
            await this.listarLicencas();
            await this.listarAssinaturas();
        }
    }

    tipoUsuario: string = null;

    async obterParaEditar() {
        let usuario = await usuarioService.obterParaEditar({
            id: this.usuarioId,
        });
        this.usuario = usuario;
        this.usuarioFoto = `${env.apiAuthUrl}/api/Picture/GetPicture?userId=${usuario.id}`;

        switch (usuario.tipo) {
            case Api.Common.Infra.Auth.PerfilTipoUsuarioEnum
                .Administrador: {
                this.tipoUsuario = 'admin';
                break;
            }

            case Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Cliente: {
                this.tipoUsuario = 'usuario';
                break;
            }

            case Api.Common.Infra.Auth.PerfilTipoUsuarioEnum.Contador: {
                this.tipoUsuario = 'empresa';
                break;
            }
        }
    }

    async salvarUsuario(tipoEditar: number) {
        if (this.areaAtual == 'admin') {
            this.$action.processSubmit({
                action: async () => {
                    if (this.usuarioId) {
                        await usuarioService.editar(this.usuario);
                    }

                    this.$snackbars.open({
                        text: 'Cadastro feito com sucesso!',
                        color: 'success',
                    });
                    await routerService.goTo('usuario-listar-editar', {
                        tipoEditar,
                    });
                },
                form: this.$refs.form,
                rules: this.rules,
            });
        }
    }

    async cancelar(tipoEditar: number) {
        let cancelado = await this.$confirm.open({
            title: 'Cancelar',
            message: 'Deseja realmente cancelar a operação ?',
        });
        if (cancelado) {
            this.$snackbars.open({
                text: 'Ação cancelada!',
                color: 'error',
            });
            await routerService.goTo('usuario-listar-editar', {
                tipoEditar,
            });
        }
    }

    rules = {
        $summary: [] as any[],
        tipo: [val.minValue(1)],
        empresas: [val.minValue(1)],
    };
}
